import { render, staticRenderFns } from "./SellingPreferences.vue?vue&type=template&id=2b9fc3c2&"
import script from "./SellingPreferences.vue?vue&type=script&lang=js&"
export * from "./SellingPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports